import { render, staticRenderFns } from "./naverIOSReturn.vue?vue&type=template&id=271ddc5d&scoped=true"
import script from "./naverIOSReturn.vue?vue&type=script&lang=js"
export * from "./naverIOSReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ddc5d",
  null
  
)

export default component.exports